import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentBanamexComponent } from '../shared/components/payment-banamex/payment-banamex.component';
import { NoSessionAuthGuard } from '../shared/guards/no-session-auth.guard';
import { canActivateChild } from '../shared/guards/permission-user.guard';
import { SessionAuthGuard } from '../shared/guards/session-auth.guard';
import { AppLayoutComponent } from './components/app-layout/app-layout.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('../features/app-auth/app-auth.module').then((m) => m.AppAuthModule),
    canActivate: [NoSessionAuthGuard],
  },
  {
    path: 'home',
    component: AppLayoutComponent,
    canActivate: [SessionAuthGuard],
    children: [
      {
        path: 'dashboard',
        pathMatch: 'full',
        redirectTo: 'experiences',
      },
      {
        path: 'banamex',
        component: PaymentBanamexComponent
      },
      {
        path: 'experiences',
        canActivate: [canActivateChild],
        data: { requiredPermission: 'VER_INFORMACION_EXP' },
        loadChildren: () => import('../features/experiences/experiences.module').then((m) => m.ExperiencesModule),
      },
      {
        path: 'venues',
        canActivate: [canActivateChild],
        data: { requiredPermission: 'VER_INFORMACION_VEN' },
        loadChildren: () => import('../features/venues/venues.module').then((m) => m.VenuesModule),
      },
      {
        path: 'users',
        canActivate: [canActivateChild],
        data: { requiredPermission: 'VER_USUARIO_US' },
        loadChildren: () => import('../features/users/users.module').then((m) => m.UsersModule),
      },
      {
        path: 'settings',
        canActivate: [canActivateChild],
        data: { requiredPermission: 'VER_PERFIL_PERMISO_PRE' },
        loadChildren: () => import('../features/settings/settings.module').then((m) => m.SettingsModule),
      },
      {
        path: 'admin',
        loadChildren: () => import('../features/admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'account',
        loadChildren: () => import('../features/account/account.module').then((m) => m.AccountModule),

      },
      {
        path: 'producer',
        loadComponent: () => import('../features/producer/producer.component').then((c) => c.ProducerComponent)
      }
    ]
  },
  {
    path: 'sale-validate',
    loadChildren: () => import('../features/sale-validate/sale-validate.module').then((m) => m.SaleValidationModule),
  },
  {
    path: '',
    loadChildren: () => import('../features/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
